/* src/app/forms/simple-filter-view/simple-filter-view.component.scss */
.accordion .mat-expansion-panel-header-title,
.accordion .mat-expansion-panel-header-description {
  flex-basis: 0;
}
.accordion .mat-expansion-panel-header-description {
  justify-content: space-between;
  align-items: center;
  flex-grow: 0;
  margin-right: 10px;
}
.cardaccordion {
  padding: 20px;
}
.filterclass {
  margin-top: 20px;
  height: 10%;
}
.filterclass2 {
  margin: 10px 0 10px 0;
}
.mat-mdc-form-field {
  font-size: 14px;
  width: 100%;
}
.vl {
  border-left: 1px solid gray;
  height: 30px;
  width: 10px;
  margin-left: 10px;
}
/*# sourceMappingURL=simple-filter-view.component.css.map */
